import { css, Interpolation, ThemedStyledProps } from 'styled-components';
import { BREAKPOINTS } from './constants';

type Breakpoint = keyof typeof BREAKPOINTS;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const media: Record<Breakpoint, (arg: Interpolation<ThemedStyledProps<any, any>>) => ReturnType<typeof css>> = {
  mobile_xs: (content) => css`
    @media (max-width: ${BREAKPOINTS.mobile_xs}px) {
      ${content}
    }
  `,
  mobile_s: (content) => css`
    @media (max-width: ${BREAKPOINTS.mobile_s}px) {
      ${content}
    }
  `,
  mobile_m: (content) => css`
    @media (max-width: ${BREAKPOINTS.mobile_m}px) {
      ${content}
    }
  `,
  mobile_l: (content) => css`
    @media (max-width: ${BREAKPOINTS.mobile_l}px) {
      ${content}
    }
  `,
  mobile_xl: (content) => css`
    @media (max-width: ${BREAKPOINTS.mobile_xl}px) {
      ${content}
    }
  `,
  tablet_s: (content) => css`
    @media (max-width: ${BREAKPOINTS.tablet_s}px) {
      ${content}
    }
  `,
  tablet: (content) => css`
    @media (max-width: ${BREAKPOINTS.tablet}px) {
      ${content}
    }
  `,
  desktop_small: (content) => css`
    @media (max-width: ${BREAKPOINTS.desktop_small}px) {
      ${content}
    }
  `,
  desktop_small_l: (content) => css`
    @media (max-width: ${BREAKPOINTS.desktop_small_l}px) {
      ${content}
    }
  `,
  desktop_medium_sm: (content) => css`
    @media (max-width: ${BREAKPOINTS.desktop_medium_sm}px) {
      ${content}
    }
  `,
  desktop_medium: (content) => css`
    @media (max-width: ${BREAKPOINTS.desktop_medium}px) {
      ${content}
    }
  `,
  desktop: (content) => css`
    @media (max-width: ${BREAKPOINTS.desktop}px) {
      ${content}
    }
  `
};

export const {
  mobile_xs,
  mobile_s,
  mobile_m,
  mobile_l,
  mobile_xl,
  tablet_s,
  tablet,
  desktop_small,
  desktop_small_l,
  desktop_medium_sm,
  desktop_medium,
  desktop
} = media;
